module.exports = __webpack_public_path__ + "img/13.1.a5968480.jpg";